import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { type ContractItem } from '../types';
import { zodContractItemResponseSchema } from '../validations';

/**
 * Reactivates a contract item for new automatic assignments.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/reactivate_contract_item_contracts__contract_id__items__item_id__reactivate_post
 */
export async function reactivateContractItem(contractId: UUID, itemId: UUID) {
  return await vestigasApi
    .post(ENDPOINT.CONTRACT_ITEM.REACTIVATE(contractId, itemId), {
      validate: { response: zodContractItemResponseSchema },
    })
    .json<ContractItem>();
}
